import { Box, Grid, Typography } from "@mui/material";

const HowMuchTypicalJobNeedsTime = ({time_description}) => {
    return (
        <Box sx={{ mb: 2, mx: 1 }}>
            <Grid container alignItems="center">
                <Grid item xs>
                    <Typography gutterBottom variant="h6" component="div">
                        <b>How much typical job needs time</b>
                    </Typography>
                </Grid>
            </Grid>
            {time_description}
        </Box>
    );
};

export default HowMuchTypicalJobNeedsTime;